import Image from '@next/image';
import classNames from 'classnames';

import { Reward } from 'types/models/Reward';
import Typography from '@components/atoms/Typography';

import classes from './RewardsSection.module.scss';

export type Props = {
  rewards: Omit<Reward, 'iconFileId'>[];
};

const RewardsSection = ({ rewards }: Props): JSX.Element => {
  const hasRangeYears = rewards.some(({ yearEnd }) => !!yearEnd);
  return (
    <ul className={classNames(classes.wrapper, { [classes.withRangeYears]: hasRangeYears })}>
      {rewards.map(({ id, icon, description, yearStart, yearEnd }, index) => {
        const isFirstItem = !index;
        const isContinueItem = !yearEnd && yearStart === rewards[index - 1]?.yearStart;
        const year = !yearEnd || yearStart === yearEnd ? yearStart : `${yearStart} - ${yearEnd}`;

        return (
          <li key={id} className={classes.item}>
            <div
              className={classNames(classes.line, {
                [classes.first]: isFirstItem,
                [classes.last]: index === rewards.length - 1,
              })}
            />
            <Typography
              className={classes.year}
              variant={isFirstItem ? 'h4' : 'body2'}
              weight={isFirstItem ? '700' : undefined}
              renderAs="span"
            >
              {!isContinueItem ? year : ''}
            </Typography>
            <div>
              <span className={classNames(classes.dot, { [classes.hidden]: isContinueItem })} />
            </div>
            <div className={classes.imageWrapper}>
              <Image
                alt={description}
                objectFit="contain"
                hasBlendMode={false}
                resolveConfig={{
                  preset: 'prize',
                  extension: icon.extension,
                  name: icon.basename,
                  height: icon.height,
                  width: icon.width,
                  description,
                }}
              />
            </div>
            <Typography
              className={classes.description}
              variant={isFirstItem ? 'h4' : 'body2'}
              weight={isFirstItem ? '700' : undefined}
              renderAs="span"
            >
              {description}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
};

export default RewardsSection;
